export const NEW_TYPE_ID = 1
export const EXISTING_LEAD_TYPE_ID = 2
export const EXISTING_PROSPECT_TYPE_ID = 3
export const HOMEOWNER_TYPE_ID = 4
export const DELETED_TYPE_ID = 5
export const OTHER_TYPE_ID = 6
export const MARKETING_ONLY_TYPE_ID = 7